// ── Invites Service — trip invite codes ──────────────────────────────────────
import { ref, set, get, remove } from 'firebase/database';
import { db }                    from '@/firebase';
import { getState }              from '@/store/tripState';

export interface TripInvite {
  code:      string;
  tripId:    string;
  tripName:  string;
  createdBy: string;
  createdAt: number;
}

function generateCode(): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  let code = '';
  for (let i = 0; i < 8; i++) {
    if (i === 4) code += '-';
    code += chars[Math.floor(Math.random() * chars.length)];
  }
  return code;
}

export async function createInvite(tripId: string, tripName: string): Promise<string> {
  const { currentUser } = getState();
  if (!currentUser) throw new Error('Não autenticado.');

  const code = generateCode();
  const invite: TripInvite = {
    code,
    tripId,
    tripName,
    createdBy: currentUser.uid,
    createdAt: Date.now(),
  };

  await set(ref(db, `tripInvites/${code}`), invite);
  return code;
}

export async function revokeInvite(code: string): Promise<void> {
  await remove(ref(db, `tripInvites/${code}`));
}

export async function resolveInvite(rawCode: string): Promise<TripInvite | null> {
  const code = rawCode.trim().toUpperCase().replace(/[^A-Z0-9]/g, '').replace(/^(.{4})(.{4})$/, '$1-$2');
  const snap = await get(ref(db, `tripInvites/${code}`));
  if (!snap.exists()) return null;
  return snap.val() as TripInvite;
}

export async function joinTripViaInvite(invite: TripInvite): Promise<void> {
  const { currentUser } = getState();
  if (!currentUser) throw new Error('Não autenticado.');

  await set(ref(db, `userTrips/${currentUser.uid}/${invite.tripId}`), true);
}
